import React from 'react';
import MUIAccordionSummary, {
  AccordionSummaryProps as MUIAccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Icon, { IconName } from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import { gutters } from 'fe-design-base/styles/utils';

interface AccordionSummaryProps
  extends Omit<MUIAccordionSummaryProps, 'children' | 'expandIcon'> {
  iconName?: IconName;
  title?: string;
  subtitle?: string;
  rightContent?: React.ReactNode;
}

const AccordionSummary = ({
  iconName,
  title,
  subtitle,
  rightContent,
  ...props
}: AccordionSummaryProps) => (
  <MUIAccordionSummary
    {...props}
    expandIcon={<Icon size="medium" iconName="ChevronDown" />}
  >
    {iconName && <Icon size="medium" iconName={iconName} mr={23} />}
    <Box display="flex" flexDirection="column" alignItems="flex-start">
      <Text variant="body">{title}</Text>
      <Text variant="bodySm" color="mono500">
        {subtitle}
      </Text>
    </Box>
    {rightContent && (
      <Box ml="auto" mr={gutters[36]}>
        {rightContent}
      </Box>
    )}
  </MUIAccordionSummary>
);

export default AccordionSummary;
